import React from 'react';

import type { T05StackChatMock } from './t05ProductStackData';



export interface T05StackChatPanelProps {

  panelTitle: string;

  chat: T05StackChatMock;

}



/** Chat-Mock für Produkt-ARKO im Product-Stack — Recherche mit LEXCORE-Belegen */

export const T05StackChatPanel: React.FC<T05StackChatPanelProps> = ({ panelTitle, chat }) => {

  return (

    <>

      <div className="t05-product-stack__panel-dots" aria-hidden>

        <span />

        <span />

        <span />

      </div>

      <div className="t05-product-stack__panel-title">{panelTitle}</div>

      <div className="t05-product-stack__chat-body" role="log" aria-label="ARKO Recherche-Chat">

        <div

          className="t05-product-stack__chat-bubble t05-product-stack__chat-bubble--user"

          aria-label="Besucherfrage"

        >

          <span className="t05-product-stack__chat-speaker" aria-hidden>

            Sie

          </span>

          {chat.userQuestion}

        </div>

        <div

          className="t05-product-stack__chat-bubble t05-product-stack__chat-bubble--arko"

          aria-label="ARKO Antwort"

        >

          <span className="t05-product-stack__chat-speaker t05-product-stack__chat-speaker--arko" aria-hidden>

            ARKO

          </span>

          {chat.arkoRef ? (

            <strong className="t05-product-stack__chat-ref">{chat.arkoRef}</strong>

          ) : null}

          {chat.arkoRef ? ' — ' : null}

          {chat.arkoAnswer}

          <span className="t05-product-stack__chat-badge">{chat.badge}</span>

        </div>

        {chat.contextLabel ? (

          <div className="t05-product-stack__chat-context">

            <span>{chat.contextLabel}</span>

            {chat.contextBadge ? (

              <span className="t05-product-stack__chat-badge t05-product-stack__chat-badge--edge">

                {chat.contextBadge}

              </span>

            ) : null}

          </div>

        ) : null}

      </div>

    </>

  );

};


